<template>
    <div>
        <img src="https://www.del-urk.nl/images/header/voorpagina_alternatief.jpg" /><br /><br />
        <h3 class="title is-3">Voor een stijlvolle begrafenis die past bij de overledene en de nabestaanden</h3>
        <br /><br /><br />
    </div>
</template>

<script>
export default {
  name: 'Del',

  data () {
    return {
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/pages/Del.vue